<template>
    <div>
        <div class="other-tenant-item-content  other-tenant-bar-code-acquisition" :data-title="barCodeAcquisition" @mouseover="acquisitionMouseover" @mouseleave="acquisitionMouseleave"
            @click="showDialog">
            <span class="other-tenant-title">条码采集量统计</span>
            <div class="bar-code-acquisition-data">
                <el-tooltip class="item" effect="dark" :content="dataList.totalCount" placement="top-start">
                    <dd class="specific-Value">{{dataList.totalCount}}</dd>
                </el-tooltip>
                <div>
                    <img class="bar-code-acquisition-increase-count-arrow" v-if="dataList.isGrowth" :src="svgObj.upGreenSvg" width="8" height="8" alt="">
                    <img class="bar-code-acquisition-increase-count-arrow" v-else :src="svgObj.downRedSvg" width="8" height="8" alt="">
                    <span :class="[dataList.isGrowth?'increase-success':'increase-fail','increase-percentage']"> {{dataList.growRate}}</span>
                </div>
            </div>
            <div>
                <span class="bar-code-acquisition-increase">环比增长 </span>
                <span class="bar-code-acquisition-increase-count">{{dataList.growCount}}</span>
            </div>
            <div v-show="acquisitionShow" class="acquisition-tootip">
                <span class="acquisition-tootip-item">{{dataList.time}}</span>
                <span v-for="(item,index) in swapStatisticsList" :key="index" class="acquisition-tootip-item">{{item.sourceSys}}采集量：{{item.count}}</span>
            </div>
        </div>
        <!-- 条码采集量统计 下钻 -->
        <el-dialog class="barCode-acquisitionRun" width="680px" height="466px" title="条码采集量统计" :visible.sync="barCodeStaticDialog" :close-on-click-modal="false" @close="closeBarCodeDialog">
            <mTable
                ref="barCodeAcquisitionRun"
                :config="tableConfig"
                :pageTotal="pageTotal"
                :tableData="tableData"
                @onSearchChange="onSearchChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange">
                <div slot="table-module-btn-left">
                    <el-button class="darkBtV3" @click="restSearchChange">重置</el-button>
                </div>
                <div slot="table-module-btn">
                    <!-- <el-button type="primary" size="mini" :loading="detailLoading">明细导出</el-button> -->
                    <el-button icon="el-icon-upload2" size="mini" class="uploadBtV3" @click="searchExport"></el-button>
                </div>
            </mTable>
        </el-dialog>
    </div>
</template>
<script>
import { formatNegative } from '@/modules/sn/utils/common';
import mTable from '@/modules/sn/components/IdentityComponent/Main';
import { config } from './tableConfig.js';
import { mapGetters } from 'vuex';
import { getAcquisitionApi, getSourceSystem } from '../../../../../../api/afterLoginIndex';
import { exportType } from '../../../../../../api/logManagement';
export default {
    name: 'barCodeAcquisition',
    components: { mTable },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            tableConfig: config,
            tableData: [],
            detailLoading: false,
            barCodeInfoList: [],
            svgObj: {
                upGreenSvg: Object,
                downRedSvg: Object
            },
            barCodeStaticDialog: false,
            barCodeAcquisition: '',
            dataList: {},
            swapStatisticsList: [],
            acquisitionShow: false,
            searchData: {}
        };
    },
    created() {
        this.svgObj.upGreenSvg = require('@/modules/sn/assets/images/icon_shangshen_green.svg');
        this.svgObj.downRedSvg = require('@/modules/sn/assets/images/icon_xiajiang_red.svg');
    },
    mounted() {
    },
    methods: {
        closeBarCodeDialog() {
            this.barCodeStaticDialog = false;
            this.tableData = [];
        },
        searchExport() {
            const { tenantCode } = this.currentTenant;
            const { sourceSys, createTime } = this.searchData;
            const [ startTime, endTime ] = createTime || [];
            const params = {
                sourceSys,
                tenantCode,
                startTime,
                endTime
            };
            const url = '/api-sn/tenantIndex/swapDownExport';
            const type = 'post';
            const name = '条码采集量统计.xls';
            exportType(params, url, type, name);
        },
        onSearchChange(data) {
            this.searchData = data;
            this.pageNo = 1;
            this.pageSize = 10;
            this.loadData();
        },
        restSearchChange() {
            if (this.$refs.barCodeAcquisitionRun) {
                this.$refs.barCodeAcquisitionRun.$refs.SearchLsit.restSearchChange();
            };
        },
        async showDialog() {
            const { tenantCode } = this.currentTenant;
            await getSourceSystem({ tenantNumber: tenantCode }).then(res => {
                if (res && +res.code === 0) {
                    const resoptions = this.conversionSystem(res.data);
                    this.tableConfig.searchList.searchTxt[0].options = resoptions;
                };
            });
            this.barCodeStaticDialog = true;
            this.restSearchChange();
        },
        conversionSystem (dictArray) {
            const dictArr = [];
            dictArray.forEach(element => {
                if (element['sourceSys']) {
                    dictArr.push({
                        label: element['sourceSys'],
                        value: element['sourceSys']
                    });
                };
            });
            return dictArr;
        },
        loadData() {
            const { tenantCode } = this.currentTenant;
            const { sourceSys = '', createTime } = this.searchData;
            if (!createTime) {
                this.$message.warning('请选择你的查询时间');
                return;
            };
            const sTime = Date.parse(createTime[0]);
            const eTime = Date.parse(createTime[1]);
            const diff = ((eTime - sTime) / 3600 / 1000 / 24);
            if (Math.ceil(diff) >= 185) {
                this.$message.warning('选取间隔不能超过6个月');
                return;
            };
            const [ startTime, endTime ] = createTime;
            const params = {
                sourceSys,
                tenantCode,
                startTime,
                endTime,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            };
            getAcquisitionApi(params).then(res => {
                if (res && +res.code === 0) {
                    const { list, totalCount } = res.data.swapStatisticsList;
                    this.tableData = [].concat(list);
                    this.pageTotal = totalCount;
                };
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageNo = 1;
            this.pageSize = data;
            this.loadData();
        },
        judgePositive(value) {
            return value >= 0;
        },
        dataProcess(data) {
            const { time, totalCount = 0, growRate = 0, growCount = 0 } = data;
            this.dataList = {
                time,
                totalCount: totalCount.toLocaleString(),
                growRate: formatNegative(growRate),
                growCount: growCount.toLocaleString(),
                isGrowth: this.judgePositive(growCount)
            };
            this.swapStatisticsList = data.swapStatisticsList.list;
        },
        acquisitionMouseover() {
            this.acquisitionShow = true;
        },
        acquisitionMouseleave() {
            this.acquisitionShow = false;
        }
    }
};
</script>
<style lang="less">
.other-tenant-bar-code-acquisition {
    position: relative;
    cursor: pointer;
    height: 116px;
    .bar-code-acquisition-data {
        margin: 20px 0 1px;
        font-family: "PingFangSC-Semibold", sans-serif;
        font-size: 18px;
        line-height: 35px;
        color: #333333;
        font-weight: 600;
        display: flex;
        min-width: 114px;
        >div {
            width: 42px;
            margin-left: 2px;
        }
        .specific-Value {
            max-width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .bar-code-acquisition-increase {
        margin-right: 2px;
        font-family: "PingFangSC-Regular", sans-serif;
        font-size: 12px;
        color: #6a706d;
        line-height: 14px;
        font-weight: 400;
    }
    .bar-code-acquisition-increase-count {
        vertical-align: middle;
        font-family: "PingFangSC-Medium", sans-serif;
        font-size: 14px;
        color: #333333;
        line-height: 14px;
        font-weight: 500;
    }
    .acquisition-tootip-item {
        display: block;
        margin-bottom: 8px;
    }
    .acquisition-tootip {
        width: 213px;
        position: absolute;
        top: 18px;
        right: 40px;
        transform: translate(100%);
        z-index: 1;
        padding: 14px 20px;
        border-radius: 2px;
        background: rgba(8, 8, 8, 0.7);
        color: #ffffff;
        font-size: 12px;
        font-family: 500;
        line-height: 12px;
        font-family: "PingFangSC-Regular", sans-serif;
        letter-spacing: 0;
    }
}
.bar-code-acquisition-increase-count-arrow {
    vertical-align: middle;
    line-height: 14px;
}
.increase-percentage {
    vertical-align: middle;
    font-family: "PingFangSC-Semibold", sans-serif;
    font-size: 10px;
    line-height: 10px;
    font-weight: 600;
}
.increase-success {
    color: #00c66b;
}
.increase-fail {
    color: #ff3c3c;
}
.mgLR6 {
    margin-left: 6px;
    margin-right: 6px;
}
.barCode-acquisitionRun {
    .nPanel .el-table {
        height: 292px !important;
    }
}
</style>
